import { render, staticRenderFns } from "./TableAdditionalPage.vue?vue&type=template&id=1dd2e26d&scoped=true&"
import script from "./TableAdditionalPage.vue?vue&type=script&lang=js&"
export * from "./TableAdditionalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2e26d",
  null
  
)

export default component.exports